/**
 * Small, delegated behaviors that don't need a custom element.
 * Everything is attached to document once, so it keeps working after Livewire morphs the DOM.
 */
export function registerBehaviors() {
    // <mellow:callout dismissible>: hide the closest dismissible container.
    document.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-mellow-dismiss]');
        const target = trigger?.closest('[data-mellow-dismissible]');
        if (!target) return;

        target.hidden = true;
        target.dispatchEvent(new CustomEvent('mellow:dismiss', { bubbles: true }));
    });

    // Disabled accordion items: pointer clicks are blocked in CSS, Enter/Space on the summary land here.
    document.addEventListener('click', (event) => {
        if (event.target.closest('summary[aria-disabled="true"]')) event.preventDefault();
    });

    // Avatars fall back to initials / icon when the image fails to load.
    const markFailed = (img) => img.setAttribute('data-failed', '');

    document.addEventListener('error', (event) => {
        if (event.target instanceof HTMLImageElement && event.target.matches('[data-mellow-avatar-image]')) {
            markFailed(event.target);
        }
    }, true);

    const scan = () => {
        document.querySelectorAll('img[data-mellow-avatar-image]').forEach((img) => {
            if (img.complete && img.naturalWidth === 0) markFailed(img);
        });
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', scan);
    } else {
        scan();
    }
    document.addEventListener('livewire:navigated', scan);
}
